import { Route, Routes } from 'react-router-dom';
import { ChallengeDetail } from './ChallengeDetail/ChallengeDetail';
import { ChallengesList } from './ChallengesList/ChallengesList';

export enum ChallengesContext {
    SubscriptionReward = 'subscription-reward',
}

export const ChallengesRoutes = () => {
    return (
        <Routes>
            <Route path=":type" element={<ChallengeDetail />} />
            <Route index element={<ChallengesList />} />
        </Routes>
    );
};